import React from "react";
import PlanoImage from "assets/cards/prontuario.svg";
import { PlanosList } from "./components/PlanosList";
import { appPrestadorStoreLink, sendAnalyticEvent } from "utils/store-link";

export const PlanosPage = () => {
  const LINK_TO_REGISTER = appPrestadorStoreLink();

  return (
    <div className="container " style={{ marginTop: "90px" }}>
      <div className="row">
        <div className="col-sm-12 col-lg-6  d-flex justify-content-center">
          <img
            className="img-fluid planos__image mirror-image"
            src={PlanoImage}
            style={{ height: "300px" }}
            height={"auto"}
            alt=""
          />
        </div>
        <div className="col-sm-12 col-lg-6">
          <div className="planos__information-container">
            <h1 className="main-title section-card__title text-center text-primary">
              Assine agora o ProntLife
            </h1>
            <h3 className="main-subtitle">
              O ProntLife é a solução ideal para a gestão de sua clínica.
              Praticidade, segurança e inteligência clínica que otimizam seu
              tempo.
            </h3>
            {/* <h5 className="planos__price planos__price-full__price text-center pt-3">
              R$ 149,90/Mês
            </h5> */}
            <h2 className="planos__price text-center pb-3">R$ 149,90/Mês</h2>
            <div className="planos__button">
              <a
                type="button"
                className="btn btn-lg btn-header rounded-pill font-weight-bold text-white my-2 mx-2"
                href={LINK_TO_REGISTER}
                onClick={() => sendAnalyticEvent()}
                target="_blank"
                rel="noreferrer noopener"
              >
                Faça um Teste Grátis
              </a>
            </div>
            {/* <p>* Desconto válido por 6 meses</p> */}
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col justify-content-center">
          <h2 className="text-center text-primary pb-2 pt-5">
            Detalhes do Plano
          </h2>
          <PlanosList />
        </div>
      </div>
    </div>
  );
};
